/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
	AxiosInstance,
	AxiosRequestConfig,
	AxiosResponse,
	// @ts-ignore - Jira Local Consumption - '"axios"' has no exported member named 'RawAxiosRequestHeaders'
	RawAxiosRequestHeaders,
	ResponseType,
} from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<
	AxiosRequestConfig,
	'data' | 'params' | 'url' | 'responseType'
> {
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseType;
	/** request body */
	body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig {
	axiosInstance: AxiosInstance;
	slauthEgress: boolean;
	slauthAudience: string;
	format?: ResponseType;
	extraHeaders?: RawAxiosRequestHeaders;
}

export enum ContentType {
	Json = 'application/json',
	FormData = 'multipart/form-data',
	UrlEncoded = 'application/x-www-form-urlencoded',
	Text = 'text/plain',
}

export class HttpClient {
	public instance: AxiosInstance;
	private format?: ResponseType;
	private slauthEgress: boolean;
	private slauthAudience: string;
	private extraHeaders?: RawAxiosRequestHeaders;

	constructor({ format, axiosInstance, slauthEgress, slauthAudience, extraHeaders }: ApiConfig) {
		this.instance = axiosInstance;
		this.format = format;
		this.slauthEgress = slauthEgress;
		this.slauthAudience = slauthAudience;
		this.extraHeaders = extraHeaders;
	}

	protected stringifyFormItem(formItem: unknown): string {
		if (typeof formItem === 'object' && formItem !== null) {
			return JSON.stringify(formItem);
		} else {
			return `${formItem}`;
		}
	}

	protected createFormData(input: Record<string, unknown>): FormData {
		return Object.keys(input || {}).reduce((formData, key) => {
			const property = input[key];
			const propertyContent: any[] = property instanceof Array ? property : [property];

			for (const formItem of propertyContent) {
				const isFileType = formItem instanceof Blob || formItem instanceof File;
				formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
			}

			return formData;
		}, new FormData());
	}

	public request = async <T = any, _E = any>({
		path,
		type,
		query,
		format,
		body,
		...params
	}: FullRequestParams): Promise<AxiosResponse<T>> => {
		const requestParams = params;
		const responseFormat = format || this.format || undefined;

		if (type === ContentType.FormData && body && typeof body === 'object') {
			body = this.createFormData(body as Record<string, unknown>);
		}

		if (type === ContentType.Text && body && typeof body !== 'string') {
			body = JSON.stringify(body);
		}

		return this.instance.request({
			...requestParams,
			headers: {
				...(this.extraHeaders || {}),
				...(requestParams.headers || {}),
				...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
				'user-agent': 'go/postoffice',
				...(this.slauthEgress ? { 'X-Slauth-Egress': 'true' } : {}),
				...(this.slauthAudience ? { 'X-Slauth-Audience': this.slauthAudience } : {}),
			},
			params: query,
			responseType: responseFormat,
			data: body,
			url: path,
		});
	};
}
